export const translations = {
  common: {
    loading: "...טוען",
    back: "חזור",
    next: "הבא",
    complete: "סיים",
    preview: "תצוגה מקדימה",
    minutes: "דקות",
  },
  auth: {
    welcomeBack: "ברוך הבא בחזרה",
    createAccount: "צור חשבון",
    resetPassword: "איפוס סיסמה",
    signInToAccount: "התחבר לחשבון שלך",
    signUpForAccount: "הרשם לחשבון חדש",
    enterEmailToReset: "הזן את כתובת האימייל שלך לאיפוס הסיסמה",
    email: "אימייל",
    password: "סיסמה",
    enterEmail: "הזן את האימייל שלך",
    enterPassword: "הזן את הסיסמה שלך",
    signIn: "התחבר",
    signUp: "הרשמה",
    dontHaveAccount: "?אין לך חשבון",
    forgotPassword: "?שכחת סיסמה",
    backToLogin: "חזרה להתחברות",
    checkEmail: "!בדוק את האימייל שלך לקבלת קישור האישור",
    checkEmailReset: "!בדוק את האימייל שלך לקבלת קישור איפוס הסיסמה",
    profile: "פרופיל",
    signOut: "התנתק",
    userEmail: "אימייל משתמש",
  },
  mealPlanner: {
    title: "התאמה אישית של תכנית הארוחות שלך",
    subtitle: "ספר לנו על ההעדפות שלך ואנחנו ניצור תכנית ארוחות מותאמת אישית",
    steps: {
      dietaryRestrictions: "הגבלות תזונה",
      cookingTime: "זמן בישול",
      cuisineAndIngredients: "מטבח ומרכיבים",
      planSettings: "הגדרות תוכנית",
    },
    mealTypes: {
      breakfast: "ארוחת בוקר",
      lunch: "ארוחת צהריים",
      dinner: "ארוחת ערב",
    },
    dietary: {
      title: "העדפות תזונה",
      vegan: "טבעוני",
      veganDesc: "ללא מוצרים מן החי",
      vegetarian: "צמחוני",
      vegetarianDesc: "ללא בשר",
      glutenFree: "ללא גלוטן",
      glutenFreeDesc: "ללא מרכיבים המכילים גלוטן",
      none: "ללא הגבלות",
      noneDesc: "כל המרכיבים מותרים",
    },
    cookingTime: {
      title: "העדפות זמן בישול",
      maxTime: "זמן בישול מקסימלי",
      description: "בחר את הזמן המקסימלי שאתה רוצה להקדיש להכנת ארוחה",
    },
    cuisine: {
      title: "העדפות מטבח",
      selectTypes: "בחר סוגי מטבח",
      ingredientPreferences: "העדפות מרכיבים",
      includeIngredients: "הוסף מרכיבים",
      excludeIngredients: "הוצא מרכיבים",
      searchInclude: "...חפש מרכיבים להוספה",
      searchExclude: "...חפש מרכיבים להוצאה",
    },
    planSettings: {
      title: "הגדרות תוכנית",
      duration: "משך התוכנית",
      servingsCount: "מספר מנות",
      days: "ימים",
      day: "יום",
      serving: "מנה",
      servings: "מנות",
    },
    preview: {
      title: "תצוגה מקדימה",
      dietaryPreferences: "העדפות תזונה",
      cookingTime: "זמן בישול",
      preferredCuisines: "מטבחים מועדפים",
      ingredients: "מרכיבים",
      include: ":כלול",
      exclude: ":הוצא",
      tips: "טיפים לתכנון ארוחות",
      tipsDescription:
        "ההעדפות שלך יעזרו לנו להציע ארוחות שמתאימות לצרכים התזונתיים שלך ולמגבלות הזמן. תוכל לעדכן העדפות אלו בכל עת.",
    },
  },
};

export const cuisineTypes = {
  Italian: "איטלקי",
  Japanese: "יפני",
  Mexican: "מקסיקני",
  Indian: "הודי",
  Mediterranean: "ים תיכוני",
  Chinese: "סיני",
  Thai: "תאילנדי",
  Israeli: "ישראלי",
  French: "צרפתי",
  MiddleEastern: "מזרח תיכוני",
  Greek: "יווני",
  Spanish: "ספרדי",
  Korean: "קוריאני",
  Vietnamese: "וייטנאמי",
  Turkish: "טורקי",
  Lebanese: "לבנוני",
  Moroccan: "מרוקאי",
  American: "אמריקאי",
};
